import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { obtenerPedidosDeBruto } from '../../actions'
import CantidadProductosPorCereal from '../../../ReporteCamiones/components/reporteCamiones/CantidadProductosPorCereal'
import moment from 'moment'

function PedidosPendientes (props) {
  const { camionesPedidos, obtenerPedidosDeBruto } = props
  const [pendientes, setPendientes] = useState([])

  useEffect(() => {
    obtenerPedidosDeBruto()
  }, [obtenerPedidosDeBruto])

  useEffect(() => {
    const pedidosPendientes = []
    if (camionesPedidos && camionesPedidos.length > 0) {
      camionesPedidos.forEach((c) => {
        const fechaPedido = moment(c.fechaDePedido).format('DD-MM HH:mm')

        pedidosPendientes.push({
          cereal: c.cereal,
          cantidad: c.pendientes,
          calle: c.calleDeBruto.replace('CALLE', 'C'),
          fecha: fechaPedido,
          calificacion: c.calificacionCereal || '',
          caravana: c.caravana
        })
      })
    }
    setPendientes(pedidosPendientes)
  }, [camionesPedidos])

  return (
    <>
      {pendientes.length > 0 &&
        <div style={{ backgroundColor: '#c5c5c5', borderRadius: '8px', padding: '8px' }}>
          <CantidadProductosPorCereal
            productosPorCereal={pendientes}
            subtitulo='Pedidos pendientes'
            detalleCalificacion
          />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state) => ({
  camionesPedidos: state.pesado.camionesPedidosBruto
})

const mapActionsToProps = {
  obtenerPedidosDeBruto
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(PedidosPendientes)
